import { Inject, Injectable } from '@angular/core'
import { SelectedDepartmentService } from '../../../../../core/services/selected-department.service'
import { IFilterDef, IFilterDefTypeEnum } from '../../../../../shared/open-layers/layer-filter.interface'

/**
 * Přidává do WFS filtrů mapových vrstev podmínku na vybraný útvar.
 *
 * DEV-2146: obě metody dřív seděly na `SelectedDepartmentService`. Ten je root singleton a patří do
 * `core/services/`, ale `core/` nesmí importovat ze `shared/` — a `IFilterDef` je OpenLayers
 * záležitost, která tam bydlí. Místo aby se ten interface tahal někam, kam nepatří, zůstala
 * OL znalost tady, u mapy: `domain/` do `shared/` sahat smí a všichni volající už tady jsou.
 *
 * Těla metod jsou přenesená beze změny, jen čtou `selectedDepartment` přes `SelectedDepartmentService`.
 */
@Injectable({
    providedIn: 'root',
})
export class DepartmentMapFilterService {

    constructor(@Inject(SelectedDepartmentService) private selectedDepartmentService: SelectedDepartmentService) {
    }

    public updateMapFilterDepartmentIdEqual(filter: IFilterDef): IFilterDef {
        if (this.selectedDepartmentService.selectedDepartment) {
            return {
                type: IFilterDefTypeEnum.And,
                args: [
                    {
                        type: IFilterDefTypeEnum.PropertyIsEqualTo,
                        propertyName: 'department_id',
                        literal: this.selectedDepartmentService.selectedDepartment.id
                    },
                    filter
                ]
            }
        }

        return filter
    }

    public updateMapFilterDepartmentIdIsLike(filter: IFilterDef): IFilterDef {
        if (this.selectedDepartmentService.selectedDepartment) {
            return {
                type: IFilterDefTypeEnum.And,
                args: [
                    {
                        type: IFilterDefTypeEnum.PropertyIsLike,
                        propertyName: 'department_id',
                        literal: '*|' + this.selectedDepartmentService.selectedDepartment.id + '|*'
                    },
                    filter
                ]
            }
        }

        return filter
    }
}
